(() => {
  const init = (root = document) => {
    const main = root.querySelector('[data-main-buy-buttons]');
    const sticky = root.querySelector('[data-mobile-sticky-atc]');
    if (!main || !sticky) return;

    const mq = window.matchMedia('(max-width: 749px)');

    const setVisible = (visible) => {
      sticky.classList.toggle('is-visible', visible);
      document.body.classList.toggle('has-mobile-sticky-atc', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };

    let observer;

    const start = () => {
      if (observer) observer.disconnect();

      // Desktop: always hidden
      if (!mq.matches) {
        setVisible(false);
        return;
      }

      observer = new IntersectionObserver(
        ([entry]) => {
          // main visible => hide sticky
          // main not visible => show sticky
          setVisible(!entry.isIntersecting);
        },
        {
          threshold: 0.01,
          // Optional: show sticky a bit earlier (when main is near bottom)
          rootMargin: '0px 0px -80px 0px'
        }
      );

      observer.observe(main);
    };

    start();
    mq.addEventListener?.('change', start);
    window.addEventListener('resize', start);
  };

  // Normal load
  document.addEventListener('DOMContentLoaded', () => init(document));

  // Shopify section reload (Theme Editor)
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
